import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterRoad, MapAdapterBoundingBox } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_ROADSIDE } from "../../../../common/constants/appRoad"

export function RoadsideDesktopRoutes() {

    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const roadworksRoutes = useMemo(() => ([
        {
            path: "/",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_ROADSIDE} />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element: <>
                <MapAdapterRoad module={API_MODULE_ROADSIDE} />
                <DetailSegmentSelectListener />
            </>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ]), [searchParams])

    return useRoutes(roadworksRoutes)
}